
const ContentSix = ({ attributes, setAttributes }) => {

    const { faqData = [] } = attributes;

    return (
        <div className='content-wrapper'>
            <div className="faq-grid content-Container">
                {faqData.map((item, idx) => (
                    <div key={item.id}
                        className="faq-item faq-card"
                        onClick={() => setAttributes({ activeItem: idx })}
                    >
                        <p className="faq-number">{idx > 8 ? '' : 0}{idx + 1}</p>
                        <div>
                            <div className='faq-question'>
                                <h3 className="faq-question-title">{item.question}</h3>
                            </div>
                            <div className="faq-answer">
                                <p className="faq-answer-para">{item.answer}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default ContentSix;